import React, { useState } from "react";

// import JS files

// import others files
import bannerSample from "../../assets/imgs/banner-sample.png";

const Writter = ({writer}) => {
  return (
    <>
      <div className="mt-16 bg-mygrays-100 rounded-lg p-4 flex flex-col md:flex-row justify-center items-center md:justify-start md:items-start">
        <img src={writer.image_file} className="rounded-lg bg-white w-20 h-20" />
        <div className="flex flex-col justify-center items-center md:justify-start md:items-start  mr-4">
          <div className="mt-4">
            <span className="font-bold text-myblacks-300 text-sm">
              {writer.name}
            </span>
          </div>
          <div className="mt-4">
            <span className=" text-myblacks-300 text-sm">{writer.position}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Writter;
